<div
  mat-dialog-title
  style="display: flex; justify-content: stretch; width: 100%"
>
  <div style="flex: 1; margin-right: 0.5rem; text-align: center">
    Dokument ausfüllen
  </div>
  <div>
    <app-document-paginator
      [data]="documentInfo"
      (pagechanged)="loadPage($event)"
    >
    </app-document-paginator>
  </div>
</div>
<mat-dialog-content #cnt class="mat-typography" style="max-height: 85%">
  <div style="position: relative; top: 0; left: 0; padding-bottom: 1rem">
    <div *ngIf="isLoading" class="document-progress-bar-placeholder"></div>
    <div *ngIf="isLoading" class="document-progress-bar-wrapper">
      <app-document-progress-bar></app-document-progress-bar>
    </div>
    <ng-container *ngIf="currentPage">
      <img *ngIf="!imgUrl" #docImg />
      <img *ngIf="imgUrl" [src]="imgUrl" [ngStyle]="currentPageStyle" />
      <div
        class="pos-absolute bg-transparent"
        style="left: 0; top: 0"
        [ngStyle]="currentPageStyle"
      >
        <!--
        class="sign-canvas-style"
      -->
        <div>
          <div
            *ngIf="actionType === 1"
            #scrollOverlay
            style="
              z-index: 1000;
              position: absolute;
              left: 0;
              top: 0;
              background-color: transparent;
            "
            [ngStyle]="currentPageStyle"
          ></div>
          <canvas
            #signCanvas
            [ngStyle]="currentPageStyle"
            style="border: 1px dashed grey"
          ></canvas>
        </div>
        <div></div>
      </div>
    </ng-container>
  </div>
</mat-dialog-content>
<div
  mat-dialog-actions
  class="row-layout pdf-dialog-actions"
  style="
    margin-top: 4px;
    padding: 1rem;
    width: 100%;
    justify-content: space-between;
  "
>
  <div>
    <button mat-button class="document-cancel" (click)="clearAll()">
      Alles leeren
    </button>
  </div>
  <div>
    Aktion:
    <mat-radio-group [value]="actionType" (change)="onActionChange($event)">
      <mat-radio-button class="edit-orders-location-radio" [value]="1"
        >Scrollen</mat-radio-button
      >
      <mat-radio-button class="edit-orders-location-radio" [value]="2"
        >Zeichnen</mat-radio-button
      >
    </mat-radio-group>
  </div>
  <div class="row-layout flex-content-end">
    <button mat-button class="document-cancel" (click)="signClose(false)">
      Abbrechen
    </button>
    <button mat-button class="document-save" (click)="signClose(true)">
      {{ data?.preferCopy ? "Kopie speichern" : "Speichern" }}
    </button>
  </div>
</div>
